export default [
  "Starter",
  "Route 101 (Gras)",
  "Route 103 (Gras)",
  "Route 102 (Gras)",
  "Route 104 (Gras)",
  "Blütenburgwald (Gras)",
  "Route 116 (Gras)",
  "Metaflurtunnel (Höhle)",
  "Granithöhle",
  "Blütenburg City (Angeln)",
  "Fausthaven (Angeln)",
  "Route 106 (Angeln)",
  "Route 107 (Angeln)",
  "Zertrümmerer",
  "Route 115 (Angeln)",
  "Route 108 (Angeln)",
  "Route 109 (Angeln)",
  "Graphitport City (Angeln)",
  "Route 110 (Gras)",
  "Route 118 (Angeln)",
  "Route 111 (Gras)",
  "Route 117 (Gras)",
  "Malvenfroh City (Stadt (eventuell Geschenk))",
  "Route 112 (Gras)",
  "Feuriger Pfad",
  "Route 113 (Gras)",
  "Bad Lavastadt (Ei)",
  "Steilpass",
  "Wüstenresort",
  "Route 114 (Gras)",
  "Route 105 (Surfen)",
  "Meteorfälle (Höhle)",
  "Route 119 (Gras)",
  "Formeo Geschenk",
  "Brutzelburg (Stadt (eventuell Geschenk))",
  "Route 120 (Gras)",
  "Route 134 (Surfer)",
  "Seewoge Malvenfroh (Surfer)",
  "Keckleon (Route 120)",
  "Baumhausen City (Keckleon)",
  "Insel im Süden",
  "Route 121 (Gras)",
  "Route 122 (Angeln)",
  "Pyroberg (Höhle)",
  "Route 123 (Gras)",
  "Safari Zone",
  "Seegrasulb City (Angeln)",
  "Route 124 (Surfen)",
  "Route 125 (Surfen)",
  "Moosbach City (Angeln)",
  "Team Aquas Versteck",
  "Geschenk von Troy",
  "Route 126 (Angeln)",
  "Küstenhöhle",
  "Xeneroville (Angeln)",
  "Geheiminsel",
  "Geheime Blumenwiese",
  "Tiefseehöhle",
  "Ursprunghöhle",
  "Route 127 (Angeln)",
  "Route 128 (Angeln)",
  "Route 129 (Angeln)",
  "Route 130 (Angeln)",
  "Route 131 (Angeln)",
  "Route 132 (Angeln)",
  "Route 133 (Angeln)",
  "Floßbrunn",
  "Wunderwald",
  "Geheime Küste",
  "Prachtpolis",
  "Siegesstraße (Höhle)",
  "Vogelencounter beim fliegen",
  "Lektroball (Static)",
  "Regice (Static)",
  "Registeel (Static)",
  "Regirock (Static)",
  "Rayquaza (Static)",
  "Kyogre / Groudon (Static)",
  "Fossil-1 (Metarost-City)",
  "Fossil-2",
  "Fossil-3",
  "Fossil-4",
  "Fossil-5",
  "Extra-1",
  "Extra-2",
  "Extra-3",
  "Extra-4",
  "Extra-5",
  "Shiny",
  "Mistmon of the Year"
];